{
	"title": "Dashboard",
	"loading": "Loading the dashboard…",
	"hero": {
		"welcome": "Welcome back,",
		"day": "Day {{day}} of {{of}}",
		"daysToGames_one": "{{n}} day to the Games",
		"daysToGames_other": "{{n}} days to the Games",
		"gamesEnded": "The Games have ended"
	},
	"kpi": {
		"live": "Live now",
		"liveSub": "Being scored right now",
		"liveNone": "Nothing is live",
		"unofficial": "To make official",
		"unofficialSub": "Finished, waiting for sign-off",
		"unofficialNone": "Nothing is waiting",
		"upNext": "Up next",
		"upNextSub": "{{ready}} with a start list · {{scheduled}} scheduled",
		"official": "Official",
		"officialSub": "{{percent}} of {{total}} meets done"
	},
	"quick": {
		"title": "Quick access",
		"meets": "All meets",
		"meetsSub": "Every sport, every day",
		"live": "Live meets",
		"liveSub": "Enter results",
		"liveCount_one": "{{count}} meet live",
		"liveCount_other": "{{count}} meets live",
		"unofficial": "Make official",
		"unofficialSub": "Sign off results",
		"unofficialCount_one": "{{count}} meet waiting",
		"unofficialCount_other": "{{count}} meets waiting",
		"medals": "Medal tally",
		"medalsSub": "Standings by NOC",
		"athletes": "Athletes",
		"athletesSub": "Entries and results",
		"teams": "Teams & entries",
		"teamsSub": "Rosters per event",
		"nocs": "NOCs",
		"nocsSub": "Delegations",
		"medalDesk": "Medal desk",
		"medalDeskSub": "Award medals in MSES",
		"setup": "Sports & events",
		"setupSub": "Set up in GMS",
		"newTab": "Opens in a new tab"
	},
	"footer": {
		"logoAlt": "SEA Games Malaysia 2027",
		"slogan": "Raikan perpaduan.",
		"sloganTranslated": "Celebrating unity."
	},
	"subtitle": {
		"during": "{{games}}, day {{day}} of {{of}}. {{date}}.",
		"before": "{{games}} starts on {{first}}. Today is {{date}}.",
		"after": "{{games}} ended on {{last}}. Today is {{date}}.",
		"unknown": "{{games}}. Today is {{date}}."
	},
	"progress": {
		"label": "Progress of the games",
		"headline_one": "{{official}} of {{total}} meet official",
		"headline_other": "{{official}} of {{total}} meets official",
		"share": "{{percent}} of the games done. Click a status to list those meets.",
		"cancelledNote_one": "{{n}} cancelled meet is not counted.",
		"cancelledNote_other": "{{n}} cancelled meets are not counted.",
		"barPart": "{{group}} {{n}}",
		"chipTitle": "List the meets: {{group}}",
		"noneTitle": "No meets in this games yet",
		"noneBody": "Meets are set up in GMS. Their progress shows here once they exist."
	},
	"rows": {
		"title": "{{event}}, {{phase}}"
	},
	"live": {
		"title": "Live now",
		"all": "All live meets",
		"empty": "No meet is live right now."
	},
	"unofficial": {
		"title": "Waiting to be made official",
		"all": "All unofficial meets",
		"allCount_one": "All {{n}}",
		"allCount_other": "All {{n}}",
		"empty": "Nothing is waiting. Every finished meet is official."
	},
	"bySport": {
		"title": "By sport",
		"subtitle": "Official meets of those to play, and what needs attention.",
		"sport": "Sport",
		"official": "Official",
		"live": "Live",
		"unofficial": "Unofficial",
		"next": "Next meet",
		"officialOf": "{{official}} / {{total}}",
		"noMeets": "No meets yet",
		"noNext": "None ahead",
		"empty": "No sports in this games yet.",
		"previous": "Previous",
		"nextPage": "Next",
		"page": "Page {{page}} of {{pages}}"
	},
	"tally": {
		"title": "Medal tally",
		"full": "Full tally",
		"rank": "Rank",
		"noc": "NOC",
		"gold": "Gold",
		"silver": "Silver",
		"bronze": "Bronze",
		"empty": "No medals awarded yet."
	},
	"noGames": {
		"title": "No games are set up yet",
		"body": "Games are created in GMS. Ask your administrator."
	},
	"errors": {
		"gamesTitle": "The games could not load",
		"countsTitle": "The meet counts could not load",
		"retry": "Try again"
	}
}
